
export default {
  props: {
    items: Array,
    tables: Boolean
  }
};
